import { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { useLocale } from '../i18n/LocaleProvider';

const safeMediaUrl = value => typeof value === 'string' && (/^https:\/\//i.test(value) || /^\/(?!\/)/.test(value));

export const VideoLightbox = ({ video, onClose }) => {
  const ref = useRef(null);
  const [failed, setFailed] = useState(false);
  const { t } = useLocale();
  useEffect(() => { setFailed(false); }, [video?.id]);
  useEffect(() => {
    if (!video) return;
    const lenis = window.__techspitzeLenis;
    lenis?.stop();
    return () => { lenis?.start(); };
  }, [video]);
  const close = () => { ref.current?.pause(); onClose(); };
  return <Dialog open={!!video} onOpenChange={open => { if (!open) close(); }}>
    <DialogContent className="testimonial-lightbox" data-testid="testimonial-lightbox" closeLabel={t('Close video')} closeTestId="testimonial-close" data-lenis-prevent>
      {video && <><DialogTitle data-testid="testimonial-player-title" translate="no">{video.title}</DialogTitle><DialogDescription data-testid="testimonial-player-customer" translate="no">{video.name} · {video.company} · {t(video.country)}</DialogDescription>
        {failed || !safeMediaUrl(video.videoUrl) ? <div className="video-error" role="alert" data-testid="testimonial-video-error"><p>{t('Video unavailable. Please try again later.')}</p><Button onClick={() => { setFailed(false); ref.current?.load(); }} data-testid="testimonial-retry" className="action-button button-secondary">{t('Try again')}</Button></div> : <video key={video.id} ref={ref} className="testimonial-player" data-testid="testimonial-player" controls playsInline preload="metadata" autoPlay={false} poster={safeMediaUrl(video.posterUrl) ? video.posterUrl : undefined} src={video.videoUrl} onError={() => setFailed(true)} aria-label={`${t('Customer feedback video')} — ${video.name}`}>
          {safeMediaUrl(video.captionsUrl) && <track kind="captions" src={video.captionsUrl} srcLang={video.captionLanguage || 'en'} label={video.captionLanguage || 'English'} />}
        </video>}
      </>}
    </DialogContent>
  </Dialog>;
};